import { useState, useEffect } from "react";

export function useNavDrawer(isLogged: boolean) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openBurger, setOpenBurger] = useState(false);

  // Cierra el drawer cuando el usuario hace login/logout
  useEffect(() => {
    setOpenDrawer(false);
  }, [isLogged]);

  const toggleDrawer = () => setOpenDrawer((s) => !s);
  const toggleBurger = () => setOpenBurger((s) => !s);
  const closeBurger = () => setOpenBurger(false);

  return { openDrawer, openBurger, toggleDrawer, toggleBurger, closeBurger };
}
